<script lang="ts">
	export let fill = "#6d6f76";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 60 60">
	<path
		d="M708.34 278.2a30 30 0 1 0 30 30 30 30 0 0 0-30-30zm-.026 14.614a1.2 1.2 0 0 1 1.2 1.2l.05 22.32a1.2 1.2 0 1 1-2.4 0l-.052-22.319a1.2 1.2 0 0 1 1.202-1.205zm.026 31.973a1.255 1.255 0 1 1 1.255-1.255 1.255 1.255 0 0 1-1.255 1.251z"
		transform="translate(-678.34 -278.196)"
		style={`fill:${fill}`} />
</svg>

<style lang="scss">
	path {
		transition: fill 0.5s;
	}

</style>
